import anonymousUser from './anonymousUser'
import articleInformalFeedbackRequestsFetchRequests from './articleInformalFeedbackRequestsFetchRequests'
import articleMeta from './articleMeta'
import articlePassword from './articlePassword'
import auth from './auth'
import breadcrumbsContext from './breadcrumbsContext'
import cardDismissals from './cardDismissals'
import wizardTourDismissals from './wizardTourDismissals'
import categories from './categories'
import channelInviteModalVisible from './channelInviteModalVisible'
import colors from './colors'
import commandLineVisible from './commandLineVisible'
import comments from './comments'
import createFromTemplateModalVisible from './createFromTemplateModalVisible'
import currentArticleId from './currentArticleId'
import documentSettingsModalVisible from './documentSettingsModal'
import educationPopovers from './educationPopovers'
import favorites from './favorites'
import filesProperties from './filesProperties'
import floatingSidebar from './floatingSidebar'
import focusMode from './focusMode'
import followees from './followees'
import forceFinderRefresh from './forceFinderRefresh'
import getter from './getter'
import globalPaywallBannerDismissed from './globalPaywallBannerDismissed'
import handbook from './handbook'
import headers from './headers'
import inboxThreads from './inboxThreads'
import informalFeedbackRequests from './informalFeedbackRequests'
import moveModalVisible from './moveModalVisible'
import navigation from './navigation'
import onboardingLoaderVisible from './onboardingLoaderVisible'
import openFolderIds from './openFolders'
import portal from './portal'
import properties from './properties'
import highlightedPropNames from './highlightedPropNames'
import articleReactions from './articleReactions'
import readReceipts from './readReceipts'
import requestedArticles from './requestedArticles'
import reviews from './reviews'
import reviewsFetchRequests from './reviewsFetchRequests'
import searchBarActive from './searchBarActive'
import shareWithTeamModalVisible from './shareWithTeamModalVisible'
import sidebar from './sidebar'
import sidebarWidth from './sidebarWidth'
import smartLinkArticlesHelper from './smartLinkArticlesHelper'
import smartLinks from './smartLink'
import snippets from './snippets'
import suggestChangesModal from './suggestChangesModal'
import suggestions from './suggestions'
import timeline from './timeline'
import todos from './todos'
import trackChanges from './trackChanges'
import unregisteredUser from './unregisteredUser'
import userArticleLikes from './likes'
import versionModalVisible from './versionModalVisible'
import deleteModalVisible from './deleteModalVisible'
import websocket from './websocket'
import workspace from './workspace'

const reducers = {
  anonymousUser,
  articleMeta,
  articlePassword,
  articleReactions,
  articleInformalFeedbackRequestsFetchRequests,
  auth,
  breadcrumbsContext,
  cardDismissals,
  wizardTourDismissals,
  categories,
  channelInviteModalVisible,
  commandLineVisible,
  colors,
  comments,
  createFromTemplateModalVisible,
  currentArticleId,
  documentSettingsModalVisible,
  educationPopovers,
  favorites,
  filesProperties,
  floatingSidebar,
  focusMode,
  forceFinderRefresh,
  followees,
  getter,
  globalPaywallBannerDismissed,
  handbook,
  headers,
  inboxThreads,
  informalFeedbackRequests,
  highlightedPropNames,
  moveModalVisible,
  navigation,
  onboardingLoaderVisible,
  openFolderIds,
  properties,
  portal,
  readReceipts,
  requestedArticles,
  reviews,
  reviewsFetchRequests,
  searchBarActive,
  shareWithTeamModalVisible,
  sidebar,
  sidebarWidth,
  smartLinkArticlesHelper,
  smartLinks,
  snippets,
  suggestChangesModal,
  suggestions,
  timeline,
  todos,
  trackChanges,
  userArticleLikes,
  unregisteredUser,
  versionModalVisible,
  deleteModalVisible,
  websocket,
  workspace,
}

export default reducers
